import { Link } from "react-router-dom";
import { Youtube, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { ASSETS, SITE } from "@/lib/assets";
import Newsletter from "@/components/Newsletter";

export default function Footer() {
  const cols = [
    { title: "Explore", links: [["About", "/about"], ["Messages", "/archives"], ["Gallery", "/gallery"], ["Blog", "/blog"]] },
    { title: "Connect", links: [["Events", "/events"], ["Book Me", "/book"], ["Prayer Requests", "/prayer"], ["Contact", "/contact"]] },
    { title: "Support", links: [["Give", "https://donate.stripe.com/fZebMa78KarQ6ROdQQ"], ["YouTube", SITE.youtube]] },
  ];

  return (
    <footer data-testid="site-footer" className="relative bg-black border-t border-white/10 pt-20 pb-10 z-10">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 pb-16">
          <div className="lg:col-span-5">
            <img src={ASSETS.logoFull} alt="Wake-Up The Nation" className="h-28 w-auto object-contain mb-6" />
            <p className="text-zinc-400 text-base max-w-sm leading-relaxed">
              A Canadian evangelistic ministry contending for revival — one awakened believer at a time.
            </p>
            <p className="mt-6 font-cond uppercase tracking-[0.2em] text-wutn text-sm">{SITE.tagline}</p>
            <div className="mt-8">
              <p className="text-xs uppercase tracking-[0.25em] text-zinc-500 mb-3">Stay Awake — Newsletter</p>
              <Newsletter />
            </div>
          </div>

          <div className="lg:col-span-4 grid grid-cols-2 sm:grid-cols-3 gap-8">
            {cols.map((col) => (
              <div key={col.title}>
                <h4 className="font-cond uppercase tracking-wider text-white text-sm mb-4">{col.title}</h4>
                <ul className="space-y-2.5">
                  {col.links.map(([label, to]) => (
                    <li key={label}>
                      {to.startsWith("http") ? (
                        <a href={to} target="_blank" rel="noreferrer" data-testid={`footer-link-${label.toLowerCase().replace(/\s/g, "-")}`} className="text-zinc-400 hover:text-wutn transition-colors text-sm inline-flex items-center gap-1">
                          {label} <ArrowUpRight className="h-3 w-3" />
                        </a>
                      ) : (
                        <Link to={to} data-testid={`footer-link-${label.toLowerCase().replace(/\s/g, "-")}`} className="text-zinc-400 hover:text-wutn transition-colors text-sm">
                          {label}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-cond uppercase tracking-wider text-white text-sm mb-4">Reach Us</h4>
            <ul className="space-y-3 text-sm text-zinc-400">
              <li className="flex items-start gap-3"><MapPin className="h-4 w-4 text-wutn mt-0.5 shrink-0" /> {SITE.location}</li>
              <li className="flex items-start gap-3"><Mail className="h-4 w-4 text-wutn mt-0.5 shrink-0" /> <a href={`mailto:${SITE.email}`} className="hover:text-wutn transition-colors">{SITE.email}</a></li>
              <li className="flex items-start gap-3"><Youtube className="h-4 w-4 text-wutn mt-0.5 shrink-0" /> <a href={SITE.youtube} target="_blank" rel="noreferrer" className="hover:text-wutn transition-colors">@WakeUpTheNation</a></li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-zinc-500">© {new Date().getFullYear()} Wake-Up The Nation Ministries. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <Link to="/admin/login" data-testid="footer-admin-link" className="text-xs text-zinc-600 hover:text-wutn font-cond uppercase tracking-wider transition-colors">Admin</Link>
            <p className="text-xs text-zinc-500 font-cond uppercase tracking-wider">With Kerby Stivene · Sundridge, ON 🇨🇦</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
